@if (showClassesChanged) {
  <div class="top-5-summary-container">
    <h4>Most Score Class Changes</h4>
    @if (classesChanged && classesChanged.length > 0) {
      <table>
        <thead>
          <th>User</th>
          <th>Case</th>
          <th>Classes Changed</th>
          <th>Run Count</th>
          <th>Open Case</th>
          <th>Case History</th>
        </thead>
        <tbody>
          @for (clss of classesChanged; track clss) {
            <tr>
              <td>{{ clss.UserName }}</td>
              <td (click)="viewHistory($event, clss)" class="clickable">
                {{ clss.ClientName }}
              </td>
              <td (click)="viewHistory($event, clss)" class="clickable">
                {{ clss.Changes }}
              </td>
              <td>{{ clss.RunCount }}</td>
              <td class="text-center">
                <button
                  mat-icon-button
                  (click)="viewCase($event, clss)"
                  matTooltip="Open Case"
                  class="pull-right"
                  color="primary"
                >
                  <mat-icon>work</mat-icon>
                </button>
              </td>
              <td class="text-center">
                <button
                  mat-icon-button
                  (click)="viewHistory($event, clss)"
                  matTooltip="View Case History"
                  class="pull-right"
                  color="warn"
                >
                  <mat-icon>history</mat-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="no-chart-data"> No Data for selected filters </div>
    }
    <ngx-loading
      [show]="loading"
      [config]="{
        fullScreenBackdrop: false
      }"
    ></ngx-loading>
  </div>
}
